"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var framer_motion_1 = require("framer-motion");
var React = __importStar(require("react"));
var react_1 = require("react");
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
var MotionPopover = framer_motion_1.motion.create(react_aria_components_1.Popover);
var StyledPopover = (0, styled_1.default)(MotionPopover)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0px 0px 4px 0px rgba(13, 20, 35, 0.12);\n  border-radius: ", ";\n  &[data-trigger='ComboBox'] {\n    margin-top: ", ";\n    min-width: 240px;\n    /* compensate for border and padding in trigger since var(--trigger-width) does not include them */\n    margin-left: -13px;\n    width: calc(var(--trigger-width) + 26px);\n  }\n\n  &[data-trigger='Select'] {\n    min-width: 240px;\n    width: var(--trigger-width);\n  }\n\n  &[data-trigger='Autocomplete'] {\n    display: flex;\n    flex-direction: column;\n    background-color: ", ";\n    border: ", " solid ", ";\n    padding: ", ";\n    gap: ", ";\n  }\n"], ["\n  box-shadow: 0px 0px 4px 0px rgba(13, 20, 35, 0.12);\n  border-radius: ", ";\n  &[data-trigger='ComboBox'] {\n    margin-top: ", ";\n    min-width: 240px;\n    /* compensate for border and padding in trigger since var(--trigger-width) does not include them */\n    margin-left: -13px;\n    width: calc(var(--trigger-width) + 26px);\n  }\n\n  &[data-trigger='Select'] {\n    min-width: 240px;\n    width: var(--trigger-width);\n  }\n\n  &[data-trigger='Autocomplete'] {\n    display: flex;\n    flex-direction: column;\n    background-color: ", ";\n    border: ", " solid ", ";\n    padding: ", ";\n    gap: ", ";\n  }\n"])), theme_1.theme.radii.card, theme_1.theme.space.space8, theme_1.theme.colors.surface300, theme_1.theme.borderWidths.regular, theme_1.theme.colors.borderNeutral, theme_1.theme.space.space16, theme_1.theme.space.space12);
/**
 * A popover component that displays content in a floating panel.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Popover.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-popover--default}
 *
 * @example
 * ```tsx
 * <DialogTrigger>
 *   <PrimaryButton>Open Dialog</PrimaryButton>
 *   <RACPopover>
 *     <Dialog>
 *       <DialogHeading>Dialog Title</DialogHeading>
 *       <Text>Dialog content</Text>
 *       <Flex
 *         flexDirection="row"
 *         justifyContent="flex-end"
 *         gap="space16"
 *       >
 *         <SecondaryButton slot="close">Cancel</SecondaryButton>
 *         <PrimaryButton>Confirm</PrimaryButton>
 *       </Flex>
 *     </Dialog>
 *   </RACPopover>
 * </DialogTrigger>
 * ```
 *
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed, extended description for the object
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param arrowBoundaryOffset - The minimum distance the arrow's edge should be from the edge of the overlay element. Defaults to 0
 * @param boundaryElement - Element that serves as the positioning boundary. Defaults to document.body
 * @param children - The content to display in the popover
 * @param className - The CSS className for the element
 * @param containerPadding - The placement padding that should be applied between the element and its surrounding container. Defaults to 12
 * @param crossOffset - The additional offset applied along the cross axis between the element and its anchor element. Defaults to 0
 * @param defaultOpen - Whether the overlay is open by default (uncontrolled)
 * @param isEntering - Whether the popover is currently performing an entry animation
 * @param isExiting - Whether the popover is currently performing an exit animation
 * @param isKeyboardDismissDisabled - Whether pressing the escape key to close the popover should be disabled. Defaults to false
 * @param isNonModal - Whether the popover is non-modal, allowing interaction with elements outside
 * @param isOpen - Whether the overlay is open by default (controlled)
 * @param maxHeight - The maxHeight specified for the overlay element
 * @param offset - The additional offset applied along the main axis between the element and its anchor element. Defaults to 8
 * @param onOpenChange - Handler that is called when the overlay's open state changes
 * @param placement - The placement of the element with respect to its anchor element. Defaults to 'bottom'
 * @param scrollRef - A ref for the scrollable region within the overlay
 * @param shouldCloseOnInteractOutside - Function to determine if popover should close on outside interaction
 * @param shouldFlip - Whether the element should flip its orientation when there is insufficient room. Defaults to true
 * @param shouldUpdatePosition - Whether the overlay should update its position automatically. Defaults to true
 * @param style - The inline style for the element
 * @param trigger - The name of the component that triggered the popover
 * @param triggerRef - The ref for the element which the popover positions itself with respect to
 */
var Popover = function (props) {
    var triggerState = (0, react_1.useContext)(react_aria_components_1.OverlayTriggerStateContext);
    return (React.createElement(StyledPopover, __assign({}, props, { style: {
            pointerEvents: (triggerState === null || triggerState === void 0 ? void 0 : triggerState.isOpen) ? 'auto' : 'none',
        }, initial: false, 
        // With initial={false}, no animations run, so isExiting should always be false
        // This tells React Aria to unmount immediately when closed
        isExiting: false }), props.children));
};
exports.Popover = Popover;
var templateObject_1;
//# sourceMappingURL=Popover.js.map